(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kavu-photo-story"]) return;
  try {
    

document.querySelectorAll('[data-kps-slider]').forEach((slider) => {

  if (slider.dataset.kpsInitialized === 'true') return;

  slider.dataset.kpsInitialized = 'true';

  const track = slider.querySelector('[data-kps-track]');
  const slides = Array.from(slider.querySelectorAll('.kps-slide'));
  const previous = slider.querySelector('[data-kps-prev]');
  const next = slider.querySelector('[data-kps-next]');
  const current = slider.querySelector('[data-kps-current]');

  if (!track || slides.length === 0) return;

  let index = 0;

  const updateHeight = () => {
    const activeSlide = slides[index];

    if (!activeSlide) return;

    requestAnimationFrame(() => {
      const height = activeSlide.getBoundingClientRect().height;

      if (height > 0) {
        track.style.height = `${height}px`;
      }
    });
  };


  const goToSlide = (newIndex) => {

    if (newIndex < 0) {
      newIndex = slides.length - 1;
    }

    if (newIndex >= slides.length) {
      newIndex = 0;
    }

    index = newIndex;

    track.scrollTo({
      left: slides[index].offsetLeft,
      behavior: 'smooth'
    });

    if (current) {
      current.textContent = index + 1;
    }

    updateHeight();
  };


  slides.forEach((slide) => {
    const image = slide.querySelector('img');

    if (!image) return;

    if (image.complete) {
      updateHeight();
    } else {
      image.addEventListener('load', updateHeight);
    }
  });


  if (previous) {
    previous.addEventListener('click', () => {
      goToSlide(index - 1);
    });
  }


  if (next) {
    next.addEventListener('click', () => {
      goToSlide(index + 1);
    });
  }


  let scrollTimer;

  track.addEventListener('scroll', () => {

    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {

let closestIndex = 0;
let closestDistance = Infinity;

slides.forEach((slide, slideIndex) => {
  const distance = Math.abs(track.scrollLeft - slide.offsetLeft);

  if (distance < closestDistance) {
    closestDistance = distance;
    closestIndex = slideIndex;
  }
});

index = closestIndex;

      if (current) {
        current.textContent = index + 1;
      }

      updateHeight();

    }, 80);

  });


  window.addEventListener('resize', updateHeight);

  updateHeight();

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
